// src/components/dispatch/components/PlanningDetails.jsx
import React from "react";

function PlanningDetails({ planningData }) {
  // ✅ Normalize planningData (handles [{...}] OR {data:{...}} OR direct {...})
  const data = Array.isArray(planningData)
    ? planningData[0]
    : (planningData?.data ? planningData.data : planningData);

  const v = (x) => (x === null || x === undefined || x === "" ? "-" : x);

    if (!data) return null;
  return (
    <div className="card shadow-sm p-4 mb-4">
      <div className="row g-3">
        <div className="col-md-4">
          <div><strong>Customer:</strong> {v(data.customer_name)}</div>
          <div><strong>PO No:</strong> {v(data.customer_po_no)}</div>
          <div><strong>PO Date:</strong> {v(data.po_date)}</div>
          <div><strong>Destination:</strong> {v(data.destination)}</div>
        </div>

        <div className="col-md-4">
          <div>
            <strong>Material:</strong> {v(data.material_name)} ({v(data.unit)})
          </div>
          <div><strong>Planned Qty:</strong> {v(data.planned_qty)}</div>
          <div><strong>Packing Style:</strong> {v(data.packing_style)}</div>
        </div>

        <div className="col-md-4">
          <div><strong>Planning Remark:</strong> {v(data.planning_remark)}</div>
        </div>
      </div>
    </div>
  );
}

export default PlanningDetails;
